/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { define } from "remount";

define(
  { "new-user-menu": App },
  {
    shadow: true,
    retarget: true,
    attributes: [
      "clientCode",
      "accountLang",
      "user",
      "sessionKey",
      // "newMenuItem",
      // "isCloseComDropDown",
      // "isGlobalSearchVisible",
    ],
  }
);
